'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { useTranslations } from 'next-intl';
import { SaveIcon } from 'lucide-react';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { ScrollArea } from '@/components/ui/scroll-area';
import { Button } from '@/components/ui/button';
import UpdateProfileForm from './update-profile-form';
import { UserType } from '@/types/user';
type PropsType = {
  user: UserType;
  open: boolean;
  onOpenChange: (open: boolean) => void;
};
const FORM_ID = 'update-profile-dialog-form';
const UpdateProfileDialog = t0 => {
  const $ = _c(23);
  const {
    user,
    open,
    onOpenChange
  } = t0;
  const t = useTranslations();
  const [isPending, setIsPending] = useState(false);
  let t1;
  if ($[0] !== t) {
    t1 = t("update_profile");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <DialogHeader><DialogTitle>{t1}</DialogTitle></DialogHeader>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== onOpenChange) {
    t3 = () => onOpenChange(false);
    $[4] = onOpenChange;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3 || $[7] !== user) {
    t4 = <ScrollArea className="min-h-0 flex-1" viewportClassName="max-h-[calc(90vh-9rem)]"><div className="px-5 pr-3 pb-5"><UpdateProfileForm user={user} formId={FORM_ID} onPendingChange={setIsPending} onSuccess={t3} /></div></ScrollArea>;
    $[6] = t3;
    $[7] = user;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <SaveIcon />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t("update_profile");
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== isPending || $[13] !== t6) {
    t7 = <DialogFooter><Button type="submit" form={FORM_ID} loading={isPending} disabled={isPending}>{t5}{t6}</Button></DialogFooter>;
    $[12] = isPending;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t2 || $[16] !== t4 || $[17] !== t7) {
    t8 = <DialogContent aria-describedby={undefined} className="sm:max-w-2xl">{t2}{t4}{t7}</DialogContent>;
    $[15] = t2;
    $[16] = t4;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== onOpenChange || $[20] !== open || $[21] !== t8) {
    t9 = <Dialog open={open} onOpenChange={onOpenChange}>{t8}</Dialog>;
    $[19] = onOpenChange;
    $[20] = open;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
};
export default UpdateProfileDialog;